import type { FullSystem, Resources } from '@stars-and-ships/api-types';
import { Pencil, Shield } from 'lucide-react';
import { useState } from 'react';
import { RESOURCE_KEYS, SYSTEM_TYPE_LABELS } from '../../labels';
import { IconButton, ResourceChip } from '../ui';
import { RenameSystemSheet } from './RenameSystemSheet';

/** Own system (spec §3.3): name, type, owner, shield, and this system's stock — not the home's. */
export function SystemHeader({
  galaxyId,
  system,
  have,
}: {
  galaxyId: string;
  system: FullSystem;
  have: Resources;
}) {
  const { caps, ratesPerHour } = system.resources;
  const [renaming, setRenaming] = useState(false);
  return (
    <header className="space-y-3">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="flex items-center gap-2">
            <h1 className="truncate font-display text-2xl font-bold uppercase tracking-[0.08em] text-text">
              {system.name}
            </h1>
            {system.ownerShielded ? (
              <Shield className="size-5 shrink-0 text-info" aria-label="Beginner shield" />
            ) : null}
            <IconButton label="Rename system" className="-my-3" onClick={() => setRenaming(true)}>
              <Pencil className="size-4" aria-hidden />
            </IconButton>
          </div>
          <p className="text-xs text-muted">
            {SYSTEM_TYPE_LABELS[system.systemType]} system · <span className="text-info">You</span>
          </p>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-2">
        {RESOURCE_KEYS.map((key) => (
          <div key={key} data-resource={key} className="flex min-w-0">
            <ResourceChip
              resource={key}
              amount={have[key]}
              cap={caps[key]}
              ratePerHour={ratesPerHour[key]}
            />
          </div>
        ))}
      </div>
      {renaming ? (
        <RenameSystemSheet
          galaxyId={galaxyId}
          system={system}
          open={renaming}
          onClose={() => setRenaming(false)}
        />
      ) : null}
    </header>
  );
}
